



























































import { Vue, Component, Prop } from 'vue-property-decorator';
import momentTz from 'moment-timezone';
import utils from '@/services/utils';

@Component
export default class LottoBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly sumFooter!: object;

  utilsInstance = utils;

  getDate(getDate: any) {
    return momentTz(getDate).format('YYYY-MM-DD hh:mm');
  }

  colorStatus(status) {
    return `${status ? 'black' : 'green'}-text`;
  }
}
